import React, { useMemo, useState } from "react";
// import { Steps } from "../../Types";
import { FormProvider, useForm } from "react-hook-form";
import { SmallContentBox } from "../../../../components/common";
import ProfessionalForm from "../ProfessionalForm";
import { useValueSet } from "../../../../hooks/useValueSet";
import { IFormInput } from "../../Types";
import { useFormatter } from "@/utils/useFormatter";

const defaultValues: IFormInput = {
  classe: undefined,
  uf: "",
  speciality: [],
  number: "",
};

export function Form() {
  const methods = useForm<IFormInput>({ defaultValues });
  const { handleSubmit, control } = methods;
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // Hook para buscar especialidades médicas usando useValueSet
  const { options: specialtiesOptions, loading: specialtiesLoading } =
    useValueSet({
      valueSet: "CBO", // ajuste conforme seu ValueSet
      searchTerm: searchTerm,
      customUrl: "https://fluxmed.cloud/fhir/r4/ValueSet/CBO-S", // ajuste se necessário
    });

  // Só exibe opções após digitar — evita lista completa bloquear o input no estado vazio
  const specialties = useMemo(
    () => {
      if (!searchTerm.trim()) return [];
      return (
        specialtiesOptions?.map((item) => ({
          value: item.code,
          label: `${item.display} - ${item.code}`,
          display: item.display,
        })) ?? []
      );
    },
    [searchTerm, specialtiesOptions],
  );

  return (
    <FormProvider {...methods}>
      <form style={{ height: "100%", width: "100%" }}>
        <SmallContentBox>
          <ProfessionalForm
            setSearchTerm={setSearchTerm}
            onNextButtonClick={handleSubmit}
            control={control}
            specialties={specialties}
            loading={loading || specialtiesLoading}
          />
        </SmallContentBox>
      </form>
    </FormProvider>
  );
}
